import React from 'react';

export default function FitSyncLogo({ className = "w-8 h-8", color = "#CCFF00" }) {
  return (
    <svg 
      viewBox="0 0 100 100" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg" 
      className={className}
    >
      {/* Outer Lab Hexagon */}
      <path 
        d="M50 5L89 27.5V72.5L50 95L11 72.5V27.5L50 5Z" 
        stroke={color} 
        strokeWidth="4" 
        strokeLinejoin="round"
        className="opacity-20"
      />
      {/* Sync Pulse Path */}
      <path 
        d="M25 50H35L42 30L58 70L65 50H75" 
        stroke={color} 
        strokeWidth="6" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        className="drop-shadow-[0_0_8px_rgba(204,255,0,0.8)]"
      >
        <animate 
          attributeName="stroke-dasharray" 
          from="0, 100" 
          to="100, 0" 
          dur="3s" 
          repeatCount="indefinite" 
        />
      </path>
      {/* Kinetic Dots */}
      <circle cx="50" cy="15" r="3" fill={color} />
      <circle cx="50" cy="85" r="3" fill={color} />
    </svg>
  );
}